import $ from 'jquery';

export function initLeerwijzer() {

    var $form = $(".leerwijzer form");

    // AS: init select2 on all select dropdowns
    $(".leerwijzer select").select2({
        minimumResultsForSearch: -1, dropdownAutoWidth: true, dropdownParent: $('.leerwijzer'), width: 'auto'
    });

    //AS: display form-groups if selected values are available
    $(".leerwijzer .question-part").each(function (idx_qp, obj_qp) {
        var $this = $(this);
        $this.toggleClass("active", $this.find("option[selected=selected]").length > 0);
    });

    //AS: display form-groups if selected values are available
    $(".leerwijzer .question-part.subject").each(function (idx_s, obj_s) {
        var $this = $(this);
        if ($this.find("option[selected=selected]").length == 0) $this.find("select").prop("disabled", "disabled").val("").trigger("change");
    });

    //AS: activate first select box for requirements
    $(".leerwijzer .requirements").addClass("active").find("select").prop("disabled", false);

    //AS: reset functions for when a user chenges a select earlier in the form
    var resetFormFrom = function (f) {

        //AS: remove submit activation trigger on reset, will be set again when needed
        $(".leerwijzer .clusters").find("select").off("change", activateSubmit);

        // AS: remove submit button on reset
        $(".leerwijzer form").find(".submit").removeClass("active");

        //AS: resets form if new requirement is reselected
        if (f == 1) {
            $(".leerwijzer .question-part:not(.requirements)").removeClass("active").find("select").prop("disabled", "disabled").val("").trigger("change");
        }

        //AS: resets form in case type is reselected
        if (f == 2) {
            $(".leerwijzer .question-part:not(.requirements,.types)").removeClass("active").find("select").prop("disabled", "disabled").val("").trigger("change");
        }

        //AS: resets form in case cluster is reselected
        if (f == 3) {
            $(".leerwijzer .subject").removeClass("active").find("select").prop("disabled", "disabled").val("").trigger("change");
        }
    };

    //AS: activates submit button
    var activateSubmit = function (e) {
        if ($(e.target).val() != "") {
            $form.find(".submit").addClass("active");
        }
    };

    //AS: when requirement is selected
    $(".leerwijzer .requirements select").on("change", function (e) {
        var $this = $(this);
        //AS: reset the form from requirement on forward
        resetFormFrom(1);
        if ($this.val() != "") {
            // AS: show cluster in case of 'weten'
            if ($this.val() == "weten") {
                var $cluster_select = $(".leerwijzer .clusters").addClass("active").find("select");
                $cluster_select.prop("disabled", false);
                $cluster_select.off("change", activateSubmit);
                $cluster_select.on("change", activateSubmit);

                //AS: set the action on the form based in which requirement needs to be shown after submit
                var site_url = $(".leerwijzer form").attr("data-siteurl");
                $form.prop("action", site_url + 'weten/');

                //AS: show types in other case
            } else {
                $(".leerwijzer .types").addClass("active").find("select").prop("disabled", false);
            }
        } else {
            //AS: remove the action on reselection
            $(".leerwijzer form").removeAttr("action");
        }
    });

    //AS: when type is selected
    $(".leerwijzer .types select").on("change", function (e) {
        var $this = $(this);
        //AS: reset the form from type on forward
        resetFormFrom(2);
        if ($this.val() != "") {
            // AS: show clusters in case of...
            if ($this.val() == "verbeteren" || $this.val() == "leerdoelen") {
                var $cluster_select = $(".leerwijzer .clusters").addClass("active").find("select");
                $cluster_select.prop("disabled", false);
                if ($this.val() == "leerdoelen") {
                    $cluster_select.off("change", activateSubmit);
                    $cluster_select.on("change", activateSubmit);
                }
                // AS: show submit button in case of 'testen'
            } else {
                $form.find(".submit").addClass("active");
            }

            //AS: set the action on the form based in which requirement needs to be shown after submit
            var site_url = $(".leerwijzer form").attr("data-siteurl") ?? '';
            $form.prop("action", site_url + $(".leerwijzer .requirements select").val() + '/' + $this.val() + '/');

        } else {
            //AS: remove the action on reselection
            $(".leerwijzer form").removeAttr("action");
        }
    });

    // AS: when cluster is selected
    $(".leerwijzer .clusters select").on("change", function (e) {
        var $this = $(this);
        var $types = $(".leerwijzer .types select");
        var $requirements = $(".leerwijzer .requirements select");
        //AS: reset the form from cluster on forward
        resetFormFrom(3);
        if ($this.val() != "") {
            // AS: show the subjects for given cluster
            if ($types.val() == "verbeteren") {
                $(".leerwijzer .subject-" + $this.val()).addClass("active").find("select").prop("disabled", false);
            }
            if ($requirements.val() == "weten" || $types.val() == "leerdoelen") {
                $this.off("change", activateSubmit);
                $this.on("change", activateSubmit);
                $form.find(".submit").addClass("active");
            }
        }
    });

    //AS: when subject is selected
    $(".leerwijzer .subject select").on("change", function (e) {
        var $this = $(this);
        var $form = $(".leerwijzer form");
        //AS: show submit button
        if ($this.val() != "") {
            $form.find(".submit").addClass("active");
        }
    });

}
